// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"8ef2f1e1","107":"f589ae07","213":"8bc43c4f","320":"934e0eeb","326":"0092c09f","488":"de94effd","613":"b81b0af8","963":"e9035da2"}[chunkId] + ".chunk.css";
};